export default "__VITE_ASSET__e5a5b076__"